import { useId } from 'react';
import { Dropdown } from 'react-bootstrap';
import { CheckIcon, ComputerDesktopIcon, MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import { ThemePreference, useTheme } from './ThemeProvider';
import styles from './ThemeSwitcher.module.css';

const choices: { value: ThemePreference; label: string; icon: typeof SunIcon }[] = [
    { value: 'light', label: 'Light', icon: SunIcon },
    { value: 'dark', label: 'Dark', icon: MoonIcon },
    { value: 'system', label: 'System', icon: ComputerDesktopIcon }
];

export function ThemeSwitcher() {
    const { preference, setPreference } = useTheme();
    const id = useId();
    const selected = choices.find(choice => choice.value === preference)!;
    return (
        <Dropdown align="end" className={styles.switcher}>
            <Dropdown.Toggle
                id={id}
                variant=""
                className={styles.toggle}
                aria-label={`Appearance: ${selected.label}`}
                title="Change appearance"
            >
                <selected.icon width={20} aria-hidden="true" />
            </Dropdown.Toggle>
            <Dropdown.Menu className={styles.menu} role="menu" aria-labelledby={id}>
                <Dropdown.Header>Appearance</Dropdown.Header>
                {choices.map(({ value, label, icon: Icon }) => (
                    <Dropdown.Item
                        key={value}
                        as="button"
                        role="menuitemradio"
                        aria-checked={preference === value}
                        active={preference === value}
                        onClick={() => setPreference(value)}
                        className={styles.option}
                    >
                        <Icon width={18} aria-hidden="true" />
                        <span>{label}</span>
                        {preference === value && <CheckIcon width={18} className={styles.check} aria-hidden="true" />}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
}
